import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContributionDistribution = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#8589f8",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "ContributionDistribution",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 15221",
				x: 15,
				y: 14.5,
				width: 14,
				height: 13,
				rx: 1,
				transform: "rotate(-180 15 14.5)",
				fill: "currentColor",
				fillOpacity: .25,
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsxs("g", {
				id: "Group 20410",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Vector",
						d: "M9.86658 10.3334L4.73324 10.3334",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_2",
						d: "M6.59998 12.2L4.73331 10.3334L6.59998 8.46671",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_3",
						d: "M6.13327 5.66672L11.2666 5.66672",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Vector_4",
						d: "M9.39994 3.80005L11.2666 5.66672L9.39993 7.53339",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			})]
		})
	})
});
export default SvgContributionDistribution;
